export default __webpack_public_path__ + "static/media/works2.e28a2f5c.png";